import React from 'react';
import { ChartCard } from '../../dashboard';

const RANK_COLORS = ['bg-primary-600', 'bg-primary-600', 'bg-primary-600', 'bg-gray-300', 'bg-gray-300', 'bg-gray-300'];

export default function AttendanceSummaryTable({ data = [] }) {
  const max = Math.max(1, ...data.map((d) => d.days));

  return (
    <ChartCard title="Top Employees by Days Attended" empty={!data.length} emptyHeight={160}>
      <div className="space-y-3">
        {data.map((emp, i) => (
          <div key={emp.id || emp.name} className="flex items-center gap-3">
            <span
              className={`w-5 h-5 shrink-0 rounded-full flex items-center justify-center text-[10px] font-bold text-white ${RANK_COLORS[i] || 'bg-gray-300'}`}
            >
              {i + 1}
            </span>
            <span className="w-28 sm:w-36 shrink-0 text-xs text-gray-700 truncate" title={emp.name}>
              {emp.name}
            </span>
            <div className="flex-1 relative h-1.5 bg-gray-100 rounded-full">
              <div
                className="absolute inset-y-0 left-0 bg-primary-500 rounded-full"
                style={{ width: `${(emp.days / max) * 100}%` }}
              />
            </div>
            <span className="w-10 shrink-0 text-right text-xs font-semibold text-gray-700">{emp.days}d</span>
          </div>
        ))}
      </div>
    </ChartCard>
  );
}
